import React, { useCallback, useState } from 'react';
import propTypes from 'prop-types';
import { SearchMethodToggle } from '../SearchMethodToggle';
import { SelectGroup } from '../SelectGroup';
import { SubmitButton } from '../leaf-components/SubmitButton';

const updateWindowLocation = (searchMethod) => {
  if (searchMethod === 'searchByVehicle') {
    window.history.replaceState(null, '', '/finder');
  } else if (searchMethod === 'searchBySize') {
    window.history.replaceState(null, '', '/finder/size');
  }
};

const TireFinder = ({ isFinderPage = false }) => {
  const { finderSearchMethod, finderSearchMethods } = drupalSettings;
  const initialSearchMethod = finderSearchMethods.find((method) => (
    method.id === finderSearchMethod
  )) || finderSearchMethods[0];

  const [selectedSearchMethod, setSelectedSearchMethod] = useState(initialSearchMethod);
  const [canSubmit, setCanSubmit] = useState(false);

  const onReadyChange = useCallback((isReady) => {
    setCanSubmit(isReady);
  }, []);

  const onSearchMethodChange = (searchMethod) => {
    setSelectedSearchMethod(searchMethod);

    if (isFinderPage) {
      updateWindowLocation(searchMethod.id);
    }
  };

  const onSubmit = (event) => {
    if (!canSubmit) {
      event.preventDefault();
    }
  };

  const currentInputs = selectedSearchMethod.inputs;
  const numberOfInputs = currentInputs.length;
  return (
    <form
      action="/finder/results"
      method="GET"
      className={`cmp-tire-finder cmp-tire-finder--${numberOfInputs}-steps`}
      data-testid="tirefinder"
      onSubmit={onSubmit}
    >
      <SearchMethodToggle
        searchMethods={finderSearchMethods}
        selectedSearchMethodId={selectedSearchMethod.id}
        onSearchMethodChange={onSearchMethodChange}
      />

      <SelectGroup
        key={selectedSearchMethod.id}
        inputs={currentInputs}
        onReadyChange={onReadyChange}
      />

      <div className="cmp-tire-finder__button-wrapper">
        <SubmitButton aria-disabled={!canSubmit}>
          Find Tires
        </SubmitButton>
      </div>
    </form>
  );
};

TireFinder.propTypes = {
  isFinderPage: propTypes.bool,
};

export { TireFinder };
